import { render } from "./BusinessView.vue?vue&type=template&id=440581f4"
import script from "./BusinessView.vue?vue&type=script&lang=js"
export * from "./BusinessView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__